import NBType from '@netbase/nb-type'
import InsightType from '../enums/InsightType'

/**
 * @typedef {import('../enums/InsightType').InsightType} InsightType
 */

/**
 * @typedef {object} InsightSchema
 * @property {string} result
 * @property {string} stemmedResult
 * @property {InsightType} type
 * @property {string[]} variants
 */
const InsightSchema = NBType.object().shape('InsightSchema', {
  /* @prop */
  result: NBType.string(),
  /* @prop */
  stemmedResult: NBType.string(),
  /* @prop */
  type: NBType.enum(InsightType),
  /* @prop */
  variants: NBType.array().of(NBType.string())
  /* END */
})
export default InsightSchema
// RESERVE BELOW
